import { render, staticRenderFns } from "./ClinicRoute.vue?vue&type=template&id=100c4a87"
import script from "./ClinicRoute.vue?vue&type=script&lang=js"
export * from "./ClinicRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports